import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box, Typography, Button, TextField, MenuItem, Select,
  FormControl, InputLabel, Paper, CircularProgress, Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import api from "../../../services/api";

const TYPE_OPTIONS = [
  { value: "pindah",            label: "Pindah Ruangan" },
  { value: "pinjam",            label: "Dipinjam" },
  { value: "kembali",           label: "Dikembalikan" },
  { value: "perbaikan",         label: "Ke Perbaikan" },
  { value: "selesai_perbaikan", label: "Selesai Perbaikan" },
  { value: "keluar",            label: "Keluar / Disposal" },
];

export default function MoveItem() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem]       = useState(null);
  const [rooms, setRooms]     = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const [form, setForm]       = useState({ to_room_id: "", type: "pindah", note: "" });

  useEffect(() => {
    api.get(`/items/${id}`).then((r) => setItem(r.data.data));
    api.get("/rooms").then((r) => setRooms(r.data.data));
  }, [id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post(`/items/${id}/move`, form);
      navigate(`/${window.location.pathname.split('/')[1]}/items/${id}`);
    } catch (err) {
      setError(err.response?.data?.message || "Gagal memindahkan barang.");
    } finally {
      setLoading(false);
    }
  };

  const fieldSx = {
    "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: "0.875rem" },
    "& .MuiInputLabel-root": { fontSize: "0.875rem" },
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
        <Button onClick={() => navigate(`/${window.location.pathname.split('/')[1]}/items/${id}`)} startIcon={<ArrowBackIcon />} size="small"
          sx={{ textTransform: "none", color: "#595959" }}>
          Kembali
        </Button>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "1.25rem", color: "#1a1a2e" }}>Pindahkan Barang</Typography>
          {item && <Typography sx={{ fontSize: "0.8rem", color: "#8c8c8c" }}>{item.name} · {item.serial_number}</Typography>}
        </Box>
      </Box>

      {/* Lokasi sekarang */}
      {item && (
        <Paper elevation={0} sx={{ border: "1px solid #e6ebf1", borderRadius: "10px", p: 2.5, mb: 2.5, backgroundColor: "#fafafa" }}>
          <Typography sx={{ fontSize: "0.78rem", color: "#8c8c8c", mb: 0.5 }}>Lokasi Sekarang</Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "0.9rem", color: "#1a1a2e" }}>
            {item.room ? `${item.room.name} (${item.room.code})` : "Belum ada ruangan"}
          </Typography>
        </Paper>
      )}

      {error && <Alert severity="error" sx={{ mb: 2, borderRadius: "8px" }}>{error}</Alert>}

      <Paper elevation={0} sx={{ border: "1px solid #e6ebf1", borderRadius: "10px", p: 3 }} component="form" onSubmit={handleSubmit}>
        <Typography sx={{ fontWeight: 600, fontSize: "0.875rem", color: "#1a1a2e", mb: 2 }}>Tujuan Perpindahan</Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <FormControl fullWidth size="small" sx={fieldSx} required>
            <InputLabel>Jenis Perpindahan</InputLabel>
            <Select name="type" value={form.type} label="Jenis Perpindahan" onChange={handleChange}>
              {TYPE_OPTIONS.map((t) => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={fieldSx} required>
            <InputLabel>Ruangan Tujuan</InputLabel>
            <Select name="to_room_id" value={form.to_room_id} label="Ruangan Tujuan" onChange={handleChange}>
              <MenuItem value=""><em>Pilih ruangan</em></MenuItem>
              {rooms.map((r) => <MenuItem key={r.id} value={r.id}>{r.name} ({r.code})</MenuItem>)}
            </Select>
          </FormControl>

          <TextField fullWidth label="Catatan (opsional)" name="note" value={form.note} onChange={handleChange}
            size="small" multiline rows={2} sx={fieldSx} placeholder="Alasan pemindahan, kondisi saat pindah, dll." />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}>
          <Button onClick={() => navigate(`/${window.location.pathname.split('/')[1]}/items/${id}`)} sx={{ textTransform: "none", color: "#595959" }}>Batal</Button>
          <Button type="submit" variant="contained" disabled={loading || !form.to_room_id}
            sx={{ textTransform: "none", borderRadius: "8px", backgroundColor: "#1677ff", "&:hover": { backgroundColor: "#0958d9" }, minWidth: 130 }}>
            {loading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Pindahkan Barang"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
